var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPending = function SvgPending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-484 -1076)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M492.793 1083.205a4.385 4.385 0 0 1-1.605 1.603c-.673.392-1.41.59-2.201.59a4.223 4.223 0 0 1-1.704-.35 4.465 4.465 0 0 1-1.398-.935 4.447 4.447 0 0 1-.934-1.406 4.313 4.313 0 0 1-.344-1.712c0-.794.195-1.528.584-2.2a4.387 4.387 0 0 1 1.6-1.602 4.263 4.263 0 0 1 2.196-.591c.792 0 1.528.198 2.2.59.677.396 1.213.93 1.606 1.603.393.673.59 1.406.59 2.2 0 .793-.195 1.532-.59 2.21zm.808-4.152c-.527-1.23-1.423-2.125-2.663-2.654a4.912 4.912 0 0 0-1.946-.399c-.678 0-1.322.134-1.941.4-1.23.527-2.13 1.42-2.657 2.653a4.87 4.87 0 0 0-.394 1.942c0 .678.129 1.33.394 1.947a4.927 4.927 0 0 0 2.657 2.659c.619.265 1.263.399 1.94.399.679 0 1.328-.135 1.947-.4a4.911 4.911 0 0 0 2.663-2.658c.265-.62.399-1.27.399-1.947 0-.679-.134-1.323-.4-1.942z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M488.827 1081.024v-2.729c0-.163-.197-.295-.424-.295-.213 0-.403.132-.403.295v2.771c0 .006.015.027.015.042-.015.095.022.174.11.238l2.19 1.575a.542.542 0 0 0 .563 0c.168-.121.157-.297 0-.411z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pending.dea695e2.svg";
export { ForwardRef as ReactComponent };